import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Renders the canonical Tech Emergency lockup as used in the site header:
 * red square with shield + pulsing dot, paired with the wordmark.
 * `size` controls overall scale.
 */
export default function FlyerLogo({ size = "md", invert = false }) {
  const dims = {
    sm: { box: 28, icon: 14, name: "text-base", sub: "text-[8px]" },
    md: { box: 36, icon: 18, name: "text-lg", sub: "text-[9px]" },
    lg: { box: 48, icon: 24, name: "text-2xl", sub: "text-[10px]" },
    xl: { box: 56, icon: 28, name: "text-3xl", sub: "text-[11px]" },
  }[size];

  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        <div
          className="flex items-center justify-center"
          style={{
            background: "var(--te-primary)",
            width: dims.box,
            height: dims.box,
          }}
        >
          <ShieldCheck size={dims.icon} color="#fff" strokeWidth={2.5} />
        </div>
        <span
          className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full"
          style={{ background: "var(--te-primary)" }}
        />
      </div>
      <div className="leading-tight">
        <div
          className={`font-extrabold tracking-tight ${dims.name}`}
          style={{ color: invert ? "#050505" : "#fff", letterSpacing: "-0.01em" }}
        >
          TECH EMERGENCY
        </div>
        <div
          className={`uppercase tracking-[0.22em] font-semibold ${dims.sub}`}
          style={{ color: invert ? "#666" : "rgba(255,255,255,0.6)" }}
        >
          Adelaide · Mobile IT
        </div>
      </div>
    </div>
  );
}
